// Vilken operation ett InvoiceMissionProgress-meddelande (SignalR) gäller.
export enum ProgressInPercentTypeEnum {
  Undefined = 0,
  CreateInvoices = 1,
  SendInvoices = 2,
}
